module.exports = __webpack_public_path__ + "img/lf3.6683bed1.png";